export default __webpack_public_path__ + "static/media/play-cricle.e1dd2603.svg";